import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/EarWipes.png'


import { PhArrowRight } from "@phosphor-icons/vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'optimizeSignalAsideTipsModalCleanTip',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// ---- CALLBACKS ----

const handleContinue = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_VCardTitle = _resolveComponent("VCardTitle")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_VCol = _resolveComponent("VCol")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_VRow = _resolveComponent("VRow")!

  return (_openBlock(), _createBlock(_component_VCol, {
    class: "flex-grow-1 d-flex h-100",
    style: {"position":"absolute","top":"0","left":"0","bottom":"0","width":"100%","height":"100%","overflow":"hidden","z-index":"2100"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, { class: "pa-6 flex-grow-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_VCardTitle, { class: "pa-0 mb-8" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Tip 2: Wipe your ears and skin ")
            ])),
            _: 1
          }),
          _createVNode(_component_VCol, { class: "px-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_VCol, { class: "ga-10" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: _imports_0,
                    style: {"height":"230px"}
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { style: {"color":"#737373","text-align":"justify","font-weight":"500","font-size":"14px"} }, " Wiping your skin with the disinfectant wipes significantly increase the contact of the electrodes. For a higher signal quality, try to put on the headphones immediately after wiping your skin. ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_VRow, {
        class: "ga-5 align-center justify-space-between position-relative w-100 px-8",
        style: {"min-height":"60px","background":"rgba(255, 255, 255, 0.45)","box-shadow":"0 8px 32px 0 rgba(31, 38, 135, 0.37)","backdrop-filter":"blur(10px)","-webkit-backdrop-filter":"blur(10px)"}
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("p", { style: {"color":"#737373","font-weight":"500","font-size":"13px"} }, "2/2", -1)),
          _createVNode(_component_VRow, { class: "align-start justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_VBtn, {
                class: "flex-grow-0 flex-shrink-1 d-flex",
                "append-icon": _unref(PhArrowRight),
                onClick: handleContinue
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Next Tip")
                ])),
                _: 1
              }, 8, ["append-icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})